module.exports = __webpack_public_path__ + "media/3.22ac64f7.mp3";